import DashboardLayout from '../../../../layouts/DashboardLayout';
import styles from '../../styles/CertificatesValidation.module.css';
import { DataTable } from '../../../../components/DataTable/DataTable';
import { useCertificatesValidation } from '../../hooks/useCertificatesValidation';
import { useEffect, useState } from 'react';
import { certificatesValidationApi } from '../../api/certificatesValidation.api';
import toast from 'react-hot-toast';
import { usePrivileges } from '../../../../hooks/usePrivileges';
import { FaInfoCircle, FaDownload, FaTimes } from 'react-icons/fa';
import CertificatesValidationModal from '../../components/CertificatesValidationModal/CertificatesValidationModal';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { ENUM_CERTIFICATES_STATUS } from '../../../emission/interfaces/certificates.interface';
import { formatCreatedAtToDate, formatCreatedAtToTime } from '../../../../services/helpers';
import { ENUM_PERMISSIONS } from '../../../../interaces/enums/enums.interface';
function CertificatesValidation() {
  const {
    entities,
    fetchSearch,
    loading,
    searchValue,
    setSearchValue,
    onClear,
    dataPagination,
    setPageData,
    pageData,
    dataFilters,
    setDataFilters,
  } = useCertificatesValidation();
  const { hasPrivilege } = usePrivileges();

  useEffect(() => {
    fetchSearch();
  }, []);

  const [openModal, setOpenModal] = useState(false);
  const [selectedCert, setSelectedCert] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);

  const closePdfModal = () => {
    if (pdfUrl) {
      window.URL.revokeObjectURL(pdfUrl);
      setPdfUrl(null);
    }
  };

  const handleDownload = async (cert) => {
    try {
      const blob = await certificatesValidationApi.downloadPdf(cert.folio);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Certificado_${(cert.tipo || 'CERTIFICADO').toUpperCase()}_${cert.folio}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      toast.error('Error al descargar el certificado.');
    }
  };

  const handleView = (cert) => {
    setSelectedCert(cert);
    setOpenModal(true);
  };

  const columns = [
    {
      accessorKey: 'folio',
      header: 'FOLIO',
    },
    {
      accessorKey: 'certificateType',
      header: 'TIPO',
    },
    {
      accessorKey: 'holder',
      header: 'TITULAR',
    },
    {
      accessorKey: 'createdAt',

      header: ({ column }) => {
        const sorted = column.getIsSorted();

        return (
          <div className="flex items-center justify-center gap-2 w-full">
            <span className="whitespace-nowrap">FECHA EMISIÓN</span>

            <div className="flex flex-col items-center justify-center">
              {sorted !== 'asc' && (
                <button
                  type="button"
                  onClick={() => column.toggleSorting(false)}
                  className="leading-none text-gray-400 hover:text-primary"
                >
                  <FaChevronDown size={16} />
                </button>
              )}

              {sorted === 'asc' && (
                <button
                  type="button"
                  onClick={() => column.toggleSorting(true)}
                  className="leading-none text-gray-400 hover:text-primary"
                >
                  <FaChevronUp size={16} />
                </button>
              )}
            </div>
          </div>
        );
      },

      cell: ({ row }) => {
        const item = row.original;

        return (
          <div>
            <p>{formatCreatedAtToDate(item.createdAt)}</p>
            <p>{formatCreatedAtToTime(item.createdAt)}</p>
          </div>
        );
      },
    },
    {
      accessorKey: 'status',
      header: 'ESTADO',
      cell: ({ row }) => {
        const status = row.original.status;
        return (
          <span
            className={`
          inline-block
          rounded-[20px]
          px-3
          py-[5px]
          text-[13px]
          font-medium
          ${status == ENUM_CERTIFICATES_STATUS.VIGENTE ? 'status-color-vigente' : status == ENUM_CERTIFICATES_STATUS.VENCIDO ? 'status-color-vencido' : status == ENUM_CERTIFICATES_STATUS.REVOCADO ? 'status-color-revocado' : 'status-color-default '}
        `}
          >
            {status}
          </span>
        );
      },
    },
    {
      id: 'acciones',
      header: 'ACCIONES',
      cell: ({ row }) => {
        const item = row.original;
        return (
          <div className="flex items-center justify-center gap-2">
            <button
              className="btn-action-view"
              onClick={() => handleView(item)}
              title="Ver validación"
            >
              <FaInfoCircle className="text-lg" />
            </button>
            <button
              className="btn-action-download"
              onClick={() => handleDownload(item)}
              title="Descargar PDF"
            >
              <FaDownload className="text-lg" />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <DashboardLayout>
      <div className="page-container">
        <div className="page-header-row">
          <div className="page-title-wrapper">
            <p className="page-subtitle">Consulta, edición y eliminación de certificados.</p>
          </div>
        </div>

        <DataTable
          columns={columns}
          data={entities}
          searchPlaceholder="Buscar certificado ..."
          pageSize={4}
          loading={loading}
          emptyMessage="No se encontraron registros"
          onSearch={() => fetchSearch()}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          showCreate={false}
          setOpenModal={setOpenModal}
          onClear={() => onClear()}
          showFilters={true}
          dataFilters={dataFilters}
          setDataFilters={setDataFilters}
          numberFilters={3}
          dataPagination={dataPagination}
          setPageData={setPageData}
          pageData={pageData}
        />
        {openModal && selectedCert && (
          <CertificatesValidationModal
            open={openModal}
            onClose={() => setOpenModal(false)}
            certificate={selectedCert}
          />
        )}

        {pdfUrl && (
          <div className={styles.pdfOverlay} onClick={closePdfModal}>
            <div className={styles.pdfBox} onClick={(e) => e.stopPropagation()}>
              <div className={styles.pdfHeader}>
                <span>Vista previa del Certificado</span>
                <button className={styles.pdfCloseBtn} onClick={closePdfModal}>
                  <FaTimes />
                </button>
              </div>
              <iframe src={pdfUrl} title="Certificado PDF" className={styles.pdfIframe} />
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}

export default CertificatesValidation;
